import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignOutAlt, faCalendarCheck, faClock } from "@fortawesome/free-solid-svg-icons";
import { Nav, Image, Navbar, Dropdown, Container } from '@themesberg/react-bootstrap';
import { Link, useHistory } from 'react-router-dom';
import { useAuth } from "../contexts/AuthContext";
import { Routes } from "../routes";
import { decodeSpecialCharacters } from "../utils/textUtils";
import { useEvents, useModals } from "../hooks";
import {
  EventAttendeesModal,
  AttendanceModal
} from '../components/modals';

import Profile3 from "../assets/img/team/profile-picture-3.jpg";


export default (props) => {
  const { user, logout } = useAuth();
  const history = useHistory();
  const events = useEvents();
  const modals = useModals();

  const handleLogout = () => {
    logout();
    history.push(Routes.Login.path);
  };

  const handleShowAttendance = async () => {
    modals.openAttendanceModal();
    events.clearEvents();
    await events.loadTodayEvents(user?.email);
  };

  const handleShowEventAttendees = async () => {
    modals.openEventAttendeesModal();
    events.clearEvents();
    events.clearEventAttendees();
    await events.loadUserEvents(user?.email);
  };

  const handleEventAttendeesSelect = (e) => {
    const eventId = e.target.value;
    
    if (eventId !== events.selectedEventId) {
      events.clearEventAttendees();
    }
    
    events.selectEventId(eventId);
    
    if (eventId) {
      events.loadEventAttendees(eventId, user.email);
    } else {
      events.clearEvents();
    }
  };

  const getAvatarUrl = () => {
    if (user?.picture) {
      return user.picture;
    }
    const decodedName = decodeSpecialCharacters(user?.name || user?.nombre || '');
    const initials = decodedName ? decodedName.split(' ').map(n => n[0]).join('').toUpperCase() : 'U';
    return `https://ui-avatars.com/api/?name=${initials}&background=262b40&color=fff&size=40`;
  };

  return (
    <Navbar variant="dark" expanded className="ps-0 pe-2 pb-0">
      <Container fluid className="px-0">
        <div className="d-flex justify-content-between align-items-center w-100">
          <div className="d-flex align-items-center">
            <Link to={Routes.Dashboard.path} style={{ textDecoration: 'none' }}>
              <img 
                src="/nuevologoIUD.png" 
                alt="Logo IUD" 
                style={{ 
                  height: '125px', 
                  width: 'auto', 
                  objectFit: 'contain',
                  marginTop: '0px',
                  marginLeft: '20px',
                  cursor: 'pointer'
                }} 
              />
            </Link>
          </div>
          <Nav className="align-items-center">

            <Dropdown as={Nav.Item}>
              <Dropdown.Toggle as={Nav.Link} className="pt-1 px-0">
                <div className="media d-flex align-items-center">
                  <Image src={user ? getAvatarUrl() : Profile3} className="user-avatar md-avatar rounded-circle" />
                  <div className="media-body ms-2 text-dark align-items-center d-none d-lg-block">
                    <span className="mb-0 font-small fw-bold">{decodeSpecialCharacters(user?.name || user?.nombre) || 'Usuario'}</span>
                    {user?.dependencia && (
                      <div className="text-muted" style={{ fontSize: '0.75rem' }}>
                        {user.dependencia}
                      </div>
                    )}
                  </div>
                </div>
              </Dropdown.Toggle>
              <Dropdown.Menu className="user-dropdown dropdown-menu-right mt-2">
                <Dropdown.Item className="fw-bold" onClick={handleShowAttendance}>
                  <FontAwesomeIcon icon={faCalendarCheck} className="text-primary me-2" /> Consultar eventos de hoy
                </Dropdown.Item>
                <Dropdown.Item className="fw-bold" onClick={handleShowEventAttendees}>
                  <FontAwesomeIcon icon={faClock} className="text-info me-2" /> Consultar invitados del evento
                </Dropdown.Item>
                <Dropdown.Item className="fw-bold" onClick={handleLogout}>
                  <FontAwesomeIcon icon={faSignOutAlt} className="text-danger me-2" /> Cerrar Sesión
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Nav>
        </div>
      </Container>
      
      {/* Modales */}
      <EventAttendeesModal
        show={modals.showEventAttendeesModal}
        onHide={modals.closeEventAttendeesModal}
        user={user}
        userEvents={events.userEvents}
        loadingEvents={events.loadingEvents}
        selectedEventId={events.selectedEventId}
        onEventSelect={handleEventAttendeesSelect}
        eventAttendees={events.eventAttendees}
        loading={events.loading}
        error={events.error}
      />

      <AttendanceModal
        show={modals.showAttendanceModal}
        onHide={modals.closeAttendanceModal}
        user={user}
        events={events.events}
        loading={events.loading}
        error={events.error}
      />
    </Navbar>
  );
};